import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import Cta from 'component/Layout/Cta';
import { CtaTheme, CtaType } from 'component/Layout/Cta/types';
import { useActiveFilter } from 'component/Search/Filter/Active/__hooks/useActiveFilter';

import {
    SearchFormActionContext,
    SearchFormContext,
} from 'context/SearchFormContext';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import styles from '../List.module.scss';

const NoResult = () => {
    const { t } = useTranslation();
    const namespace = useContext(CommunicationContext);
    const { activeFilterList } = useContext(SearchFormContext);
    const { removeAllActiveFilter } = useContext(SearchFormActionContext);
    const hasActiveFilter = !!activeFilterList.length;
    const { removeAllActiveFilterFromSearch } = useActiveFilter();

    const onResetFilter = () => {
        removeAllActiveFilter(); // Filter chips
        removeAllActiveFilterFromSearch(activeFilterList); // Filter
    };

    let lastSearchUrl: string =
        namespace.components.jLocalStorage?.getTabSessionItem(
            'last_step3_url_with_offers'
        ) || '';
    if (lastSearchUrl === window.location.href) {
        lastSearchUrl = '';
    }
    const showPageLoader = () => {
        namespace.react.dispatch('react-pageloader-show-loader', () => {});
    };

    return (
        <div className={styles.NoResult}>
            {t('TRANS-no-search-result')}
            {lastSearchUrl ? (
                <Cta
                    type={CtaType.LINK}
                    link={lastSearchUrl}
                    customClassList={{ Cta: styles.Cta }}
                    onClick={showPageLoader}
                >
                    {t('TRANS-to-last-result')}
                </Cta>
            ) : (
                hasActiveFilter && (
                    <Cta
                        type={CtaType.BUTTON}
                        theme={CtaTheme.INVERTED}
                        customClassList={{ Cta: styles.Cta }}
                        onClick={onResetFilter}
                    >
                        {t('TRANS-reset-filters')}
                    </Cta>
                )
            )}
        </div>
    );
};

export default NoResult;
